<template>
  <div @click="toggleColor" :class="[{'is-active': isActive}, 'ColorFilter--' + color, 'ColorFilter']">
    <IconBase iconName="check" iconColor="#000"><IconCheck /></IconBase>
  </div>
</template>

<script>
import IconCheck from "./icons/IconCheck";

export default {
  props: {
    color: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    }

  },
  methods: {
    toggleColor() {
      this.$emit("toggleColor", this.color);
    }
  },
  components: {
    IconCheck
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.ColorFilter {
  width: 40px;
  height: 40px;
  border-radius: $global-radius;
  border: 2px solid #fff;
  cursor: pointer;

  &--rose {
    background-color: $color-wine-rose;
  }

  &--white {
    background-color: $color-wine-white;
  }

  &--yellow {
    background-color: $color-wine-yellow;
  }

  &--red {
    background-color: $color-wine-red;
  }

  &--fizzy {
    background: $color-wine-fizzy url('../assets/images/fizzy.svg') center center;
  }

  svg {
    display: none;
  }

  &.is-active {
    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      opacity: 0.3;
      display: block;
    }
  }
}
</style>
